import type { BadgeRule } from "~/lib/badges/types";

export const exclusionTagsRule: BadgeRule = {
  name: "exclusionTags",
  evaluate: (product, badge) => {
    if (!badge.criteriaTagsExclude.length) return true;
    return !badge.criteriaTagsExclude.some((tag) => product.tags.includes(tag));
  },
};
